import React from "react";
import { useDispatch } from "react-redux";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import { GetCompanyByIdResponse, GetCompanyByIdResponseCompanyAddress } from "../../../../models/response/company/GetCompanyByIdResponse";
import { GetCompanyListResponse, GetCompanyListResponseItem } from "../../../../models/response/company/GetCompanyListResponse";
import { storeActivityIndicator, storeFastFirm } from "../../../../redux/reducers/authSlice";
import { CompanyService } from "../../../../services/CompanyService";
import { LocationInformationModel } from "./LocationInformation";
import toast from "react-hot-toast";

interface Props {
    selectedVariableCompany: CustomSingleSelectModel | undefined
    setSelectedVariableCompany: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setSelectedVariableAddressType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setVariableAddressText: React.Dispatch<React.SetStateAction<string | undefined>>
    variableAddressList: GetCompanyByIdResponseCompanyAddress[]
    selectedVariableAddressType: CustomSingleSelectModel | undefined
    variableAddressText: string | undefined
    getCompanyById: (_companyId: string, setVariableAddressList: React.Dispatch<React.SetStateAction<GetCompanyByIdResponseCompanyAddress[]>>, setSelectedVariableAddressType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>, setVariableAddressText: React.Dispatch<React.SetStateAction<string | undefined>>) => Promise<void>
    setVariableAddressList: React.Dispatch<React.SetStateAction<GetCompanyByIdResponseCompanyAddress[]>>
    className: string
    text: string
    additionalEvent: ((selectedValue: CustomSingleSelectModel | undefined) => void) | undefined
    setInformation: React.Dispatch<React.SetStateAction<LocationInformationModel>> | undefined
    isSenderFirm: boolean,
    isReceiverFirm: boolean,
}

const AddressComponent = ({
    selectedVariableCompany,
    setSelectedVariableCompany,
    setSelectedVariableAddressType,
    setVariableAddressText,
    variableAddressList,
    selectedVariableAddressType,
    variableAddressText,
    getCompanyById,
    setVariableAddressList,
    className,
    text,
    additionalEvent,
    setInformation,
    isSenderFirm,
    isReceiverFirm,
}: Props) => {
    const dispatch = useDispatch();

    const companySelectHandler = (selectedValue: CustomSingleSelectModel | undefined) => {
        if (selectedValue) {
            setSelectedVariableCompany(selectedValue);
            getCompanyById(selectedValue.value, setVariableAddressList, setSelectedVariableAddressType, setVariableAddressText);
        }
        else {
            setSelectedVariableCompany(undefined);
            setSelectedVariableAddressType(undefined);
            setVariableAddressText('');
            setVariableAddressList([]);
        }

        if (additionalEvent)
            additionalEvent(selectedValue);
    }

    const addressTypeSelectHandler = async (selectedValue: CustomSingleSelectModel | undefined, _companyId: string | undefined = undefined) => {
        try {
            dispatch(storeActivityIndicator(true))
            if (selectedValue) {
                var a: GetCompanyByIdResponseCompanyAddress | undefined = undefined;
                var addressText: string | undefined = undefined;

                if (_companyId) {
                    var response: GetCompanyByIdResponse = await CompanyService.getCompanyById(_companyId);

                    if (!response.isSuccess) {
                        toast.error(response.message)
                        return;
                    }

                    setVariableAddressList(response.data.companyAddresses);

                    a = response.data.companyAddresses.find(x => x.addressTypeId == selectedValue.value);
                    addressText = response.data.companyAddresses.find(x => x.addressTypeId == selectedValue.value)?.addressText;
                }

                if (!a) {
                    a = variableAddressList.find(x => x.addressTypeId == selectedValue.value);
                }

                if (!addressText)
                    addressText = variableAddressList.find(x => x.addressTypeId == selectedValue.value)?.addressText;

                if (a) {
                    setSelectedVariableAddressType(selectedValue);
                    setVariableAddressText(addressText);

                    if (setInformation) {
                        setInformation({
                            selectedCountry: a.countryId ? { label: a.countryName + '', value: a.countryId } : undefined,
                            selectedCounty: a.countyId ? { label: a.countyName + '', value: a.countyId } : undefined,
                            selectedDistrict: a.districtId ? { label: a.districtName + '', value: a.districtId } : undefined
                        })
                    }
                }
            }
            else {
                setSelectedVariableAddressType(undefined);
                setVariableAddressText('');

                if (setInformation) {
                    setInformation({
                        selectedCountry: undefined,
                        selectedCounty: undefined,
                        selectedDistrict: undefined
                    })
                }
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    return (
        <div className={'row ' + className}>
            <div className="col-md-4">
                <label htmlFor="exampleFormControlInput1" className="form-label required">{text}</label>

                <CustomSingleSelect
                    selectedValue={selectedVariableCompany}
                    onChange={companySelectHandler}
                    insertable={{
                        tooltipText: 'Firma seçilmeden basıldığında Yeni firma tanımlaması yapılmasını, firma seçimi yapıldıktan sonra basıldığında ise seçilen firmanın bilgilerinin Güncellenmesini sağlar.',
                        onClick: () => {
                            dispatch(storeFastFirm({
                                companyId: selectedVariableCompany?.value,
                                addressTypeId: selectedVariableAddressType?.value,
                                isSenderFirm: isSenderFirm,
                                isReceiverFirm: isReceiverFirm,
                                onSubmit: async (response) => {
                                    companySelectHandler({ label: response.name, value: response.companyId })
                                }
                            }))
                        }
                    }}
                    onMenuOpen={() => CompanyService.getCompanyList({ isSenderFirm: isSenderFirm == undefined || isSenderFirm == false ? undefined : true, isReceiverFirm: isReceiverFirm == undefined || isReceiverFirm == false ? undefined : true })}
                    labelName='name'
                    valueName='companyId'
                />
            </div>

            <div className="col-md-4">
                <label htmlFor="exampleFormControlInput1" className="form-label required">Adres Türü</label>

                <CustomSingleSelect
                    selectedValue={selectedVariableAddressType}
                    onChange={addressTypeSelectHandler}
                    insertable={!selectedVariableCompany ? undefined : {
                        tooltipText: 'Seçilmiş olan firmaya Yeni adres tanımlama işlemini sağlar.',
                        onClick: () => {
                            dispatch(storeFastFirm({
                                companyId: selectedVariableCompany?.value,
                                // addressTypeId: selectedVariableAddressType?.value,
                                isJustAddress: true,
                                isSenderFirm: isSenderFirm,
                                isReceiverFirm: isReceiverFirm,
                                onSubmit: async (response) => {
                                    if (response.companyAddresses.length > 0) {
                                        addressTypeSelectHandler({ label: response.companyAddresses[0].addressTypeName, value: response.companyAddresses[0].addressTypeId }, response.companyId);
                                    }
                                }
                            }))
                        }
                    }}
                    onMenuOpen={selectedVariableCompany ? () => CompanyService.getCompanyById(selectedVariableCompany.value) : undefined}
                    labelName='addressTypeName'
                    valueName='addressTypeId'
                    innerPropName="companyAddresses"
                />
            </div>

            <div className="col-md-4">
                <label htmlFor="exampleFormControlInput1" className="form-label required">Açık Adres</label>

                <input style={{ border: '1px solid #F1F1F4' }} value={variableAddressText} onChange={(e) => setVariableAddressText(e.target.value)} type="text" className="form-control form-control-solid" />
            </div>
        </div>
    )
}

AddressComponent.defaultProps = {
    additionalEvent: undefined,
    setInformation: undefined,
    isSenderFirm: false,
    isReceiverFirm: false,
    isDutyFirm: false,
}

export default AddressComponent;